import React from 'react';
import { LucideIcon, ArrowUp, ArrowDown } from 'lucide-react';

export interface StatItem {
  id: string;
  label: string;
  value: string | number;
  change?: string;
  trend?: 'up' | 'down' | 'neutral';
  icon: LucideIcon;
  color: string;
}

interface StatsOverviewProps {
  stats: StatItem[];
}

export const StatsOverview: React.FC<StatsOverviewProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats.map((stat) => (
        <div 
          key={stat.id} 
          className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-5 shadow-sm"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`p-3 rounded-lg bg-${stat.color}-50 dark:bg-${stat.color}-900/20 text-${stat.color}-600 dark:text-${stat.color}-400`}>
              <stat.icon className="size-6" />
            </div>
            {stat.change && (
              <span className={`
                flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-full
                ${stat.trend === 'up' 
                  ? 'bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-400' 
                  : stat.trend === 'down'
                  ? 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-400'
                  : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400'
                }
              `}>
                {stat.trend === 'up' && <ArrowUp className="size-3" />}
                {stat.trend === 'down' && <ArrowDown className="size-3" />}
                {stat.change}
              </span>
            )}
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-slate-900 dark:text-slate-100">
              {stat.value}
            </h3>
            <p className="text-sm text-slate-500 dark:text-slate-400 font-medium">
              {stat.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
